module.exports = __webpack_public_path__ + "media/images/no_content.icon.recommendation-0b3dde14.png";